import { z } from "@/zod";
import { ulid } from "@/schemas/commonFields";
import { nonNegativeDecimalStringSchema } from "@/schemas/commonFields/numberSchema";

/**
 * Schema for cost item used in invoice specifications
 * Extracted from invoiceSpecificationFormSchema.costs array element
 */
export const costItemSchema = z.object({
  name: z.string().trim().min(1).max(100),
  amount: nonNegativeDecimalStringSchema,
  comment: z
    .string()
    .trim()
    .max(250)
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
});

/**
 * Schema for cost item with ID (used in components)
 */
export const costItemWithIdSchema = costItemSchema.extend({
  id: ulid,
});

/**
 * Readonly schema for cost item with ID (used in List component)
 */
export const costsReadSchema = costItemWithIdSchema.readonly();

export const costsUpdateSchema = z.object({
  costs: z
    .array(
      z.object({
        id: ulid.optional(), // Optional for new costs, required for updates
        name: z.string().trim().min(1).max(100),
        amount: nonNegativeDecimalStringSchema,
        comment: z.string().trim().min(1).max(250).optional(),
      }),
    )
    .optional(),

  costs_delete: z.array(z.string()).optional(),
});
